// helpers
function getQueryArray(query) {
  return Array.isArray(query) ? query : query ? [query] : [];
}
function addToFilter(filter, name, value) {
  if (value !== undefined) filter[name] = value || undefined;
}
function getQueryFilter(filterQuery, filterKey) {
  return computed({
    get() {
      return filterQuery.value[filterKey];
    },
    set(value) {
      filterQuery.value = { [filterKey]: value };
    },
  });
}

/**
 * Get query filter state
 * @param {object[]} filtersData filters data
 * @param {string} filtersData.key filter key
 * @param {string} filtersData.initialValue filter initial value
 */
export const useQueryFilter = (filtersData = []) => {
  const route = useRoute();
  const router = useRouter();

  const initialFilter = filtersData.reduce((result, filterData) => {
    result[filterData.key] = filterData.initialValue;
    return result;
  }, {});

  const filterQuery = computed({
    get() {
      const { query } = route;

      return filtersData.reduce((result, filterData) => {
        const filterValue = query[filterData.key];

        result[filterData.key] = Array.isArray(filterData.initialValue)
          ? getQueryArray(filterValue)
          : filterValue || null;

        return result;
      }, {});
    },
    set(value) {
      const filters = {};
      const addFilter = (name, value) => addToFilter(filters, name, value);

      filtersData.forEach((filterData) => {
        addFilter(filterData.key, value[filterData.key]);
      });

      router.push({ query: { ...route.query, ...filters } });
    },
  });

  const filterModels = reactive(
    filtersData.reduce((result, filterData) => {
      result[filterData.key] = getQueryFilter(filterQuery, filterData.key);

      return result;
    }, {}),
  );

  return { initialFilter, filterQuery, filterModels };
};
